import { useState, useEffect, useRef } from 'react';
import io from 'socket.io-client';
import { obtenerMensajesNoLeidos } from '../services/chatService';

const useMessageNotifications = (user) => {
  const [mensajesNoLeidos, setMensajesNoLeidos] = useState(0);
  const [showChat, setShowChat] = useState(false);
  const socketRef = useRef(null);

  useEffect(() => {
    if (user && user.id) {
      socketRef.current = io();

      const cargarMensajesNoLeidos = async () => {
        try {
          const response = await obtenerMensajesNoLeidos(user.id);
          if (response.success) {
            setMensajesNoLeidos(response.count);
          }
        } catch (error) {
          console.error('Error al cargar mensajes no leídos:', error);
        }
      };

      cargarMensajesNoLeidos();


      socketRef.current.on(`new_message_${user.id}`, (data) => {
        if (!showChat) {
          setMensajesNoLeidos(prev => prev + 1);
        }
      });


      socketRef.current.on(`unread_count_${user.id}`, (count) => {
        setMensajesNoLeidos(count);
      });


      socketRef.current.on('message_status_change', (data) => {
        if (data.userId === user.id) {
          setMensajesNoLeidos(0);
        }
      });

      // Notificar conexión del usuario
      socketRef.current.emit('user_connected', user.id);

      return () => {
        if (socketRef.current) {
          socketRef.current.emit('user_disconnected', user.id);
          socketRef.current.off(`new_message_${user.id}`);
          socketRef.current.off(`unread_count_${user.id}`);
          socketRef.current.off('message_status_change');
          socketRef.current.disconnect();
        }
      };
    }
  }, [showChat, user]);

  useEffect(() => {
    if (showChat && user && user.id && socketRef.current) {
      socketRef.current.emit('messages_read', {
        userId: user.id,
        emisorId: null
      });
    }
  }, [showChat, user]);

  const handleChatOpen = () => {
    setShowChat(true);
  };

  const handleChatClose = () => {
    setShowChat(false);
  };

  const handleMessageRead = () => {
    if (user && user.id && socketRef.current) {
      socketRef.current.emit('messages_read', {
        userId: user.id,
        emisorId: null
      });
    }
  };

  return {
    mensajesNoLeidos,
    showChat,
    handleChatOpen,
    handleChatClose,
    handleMessageRead
  };
};

export default useMessageNotifications;